module.exports = __webpack_public_path__ + "static/media/become-bg.eec63567.png";